import moment from "jalali-moment";
import { v4 as uuidv4 } from "uuid";
export const fancyTimeFormat = duration => {
  var hrs = ~~(duration / 3600);
  var mins = ~~((duration % 3600) / 60);
  var secs = ~~duration % 60;
  var ret = "";
  if (hrs > 0) {
    ret += "" + hrs + ":" + (mins < 10 ? "0" : "");
  }
  ret += "" + mins + ":" + (secs < 10 ? "0" : "");
  ret += "" + secs;
  return ret;
};

export const ToDateJalali = date => {
  if (date) {
    return moment(date).locale("fa").format("YYYY/MM/DD");
  } else {
    return null;
  }
};
export const ToDateDayMonthJalali = date => {
  if (date) {
    return moment(date).locale("fa").format("MM/DD");
  } else {
    return null;
  }
};
export const CostRender = new Intl.NumberFormat("en-US");

export const ConvertDate = date => {
  if (date) {
    return moment.from(date, "fa", "YYYY/MM/DD").format("YYYY/MM/DD");
  } else {
    return null;
  }
};

export const ToTimeJalali = date => {
  if (date) {
    return moment(date).locale("fa").format(" HH:mm:ss - YYYY/MM/DD");
  } else {
    return null;
  }
};

export const ToTime = (date, sec = false) => {
  if (date) {
    if (sec) {
      return moment(date).locale("fa").format("HH:mm");
    } else {
      return moment(date).locale("fa").format("HH:mm:ss");
    }
  } else {
    return null;
  }
};
export const ToTimeHM = date => {
  if (date) {
    return moment(date).locale("fa").format("HH:mm");
  } else {
    return null;
  }
};
export const GenderRender = value => {
  let gender;
  switch (value) {
    case "men":
    case "man":
      gender = "آقایان";
      break;
    case "women":
    case "woman":
      gender = "بانوان";
      break;
    case "both":
      gender = "هردو";
      break;
    default:
      break;
  }
  return gender;
};
export const Day = day => {
  switch (day) {
    case "Fri":
    case "Friday":
      return "جمعه";
    case "Thu":
    case "Thursday":
      return "پنجشنبه";
    case "Wed":
    case "Wednesday":
      return "چهار شنبه";
    case "Tue":
    case "Tuesday":
      return "سه شنبه";
    case "Mon":
    case "Monday":
      return "دوشنبه";
    case "Sun":
    case "Sunday":
      return "یکشنبه";
    case "Sat":
    case "Saturday":
      return "شنبه";
    default:
      return "روز نا مشخص";
  }
};
export const ToDateMonthJalali = date => {
  if (date) {
    return moment(date).locale("fa").format("YYYY/MM");
  } else {
    return null;
  }
};
export const getPosition = (string, index) => {
  return `${string.substring(0, index)}...`;
  // return string.split(subString).slice(index).join(subString);
};
export const randomBetweenToNumber = (min, max) => {
  return uuidv4();
};

export const dateInputYMD = date => {
  var result = new Date(date);
  var month = result.getUTCMonth() + 1; //months from 1-12
  var day = result.getUTCDate();
  var year = result.getUTCFullYear();
  return year + "/" + month + "/" + day;
};
export const addTime = min => {
  return moment().add(min, "m").format();
};
export const RenderPrice = data => {
  const { price } = data;
  if (data.second_price) {
    return `${CostRender.format(data.second_price)} ${window.screen.width > 760 ? "تومان" : ""} `;
  }
  return `${CostRender.format(price)} ${window.screen.width > 760 ? "تومان" : ""} `;
};
export const sepMony = data => {
  let dataNum = fixNum(data);
  return `${CostRender.format(dataNum)} ${window.screen.width > 760 ? "تومان" : ""} `;
};

export const fixNum = (num) => {
  let persianNumbers = [/۰/g, /۱/g, /۲/g, /۳/g, /۴/g, /۵/g, /۶/g, /۷/g, /۸/g, /۹/g],
    arabicNumbers = [/٠/g, /١/g, /٢/g, /٣/g, /٤/g, /٥/g, /٦/g, /٧/g, /٨/g, /٩/g];
  if (typeof num === 'string') {
    for (var i = 0; i < 10; i++) {
      num = num.replace(persianNumbers[i], i).replace(arabicNumbers[i], i);
    }
  }
  return num;
}

export const sepJustMoney = data => {

  let dataNum = fixNum(data);

  if (dataNum == "" || dataNum == null) {
    return dataNum;
  }
  let newMoney = dataNum;
  if (typeof dataNum != "number") {
    newMoney = dataNum.replace(/\D/g, '');
  }
  return CostRender.format(newMoney);

};
export const removeSepMoney = (price) => {
  if (!price || price == "") {
    return price
  }
  let newPrice = price.split(',');
  newPrice = newPrice.join("");
  return newPrice
};

export const renderPrice = price => {
  return `${CostRender.format(price)} ${window.screen.width > 760 ? "تومان" : ""} `;
};
const renderData = data => {
  if (data.includes(":")) {
    if (+data.split(":")[0] * 60 + +data.split(":")[1] == 0) {
      return 24 * 60;
    }
    if (+data.split(":")[0] * 60 + +data.split(":")[1] < 240) {
      return 24 * 60;
    }

    return +data.split(":")[0] * 60 + +data.split(":")[1];
  } else {
    return +data * 60;
  }
};
const compareTwoHour = time => {
  let now = new Date();
  if (
    time &&
    renderData(time.split("-")[0].toString()) <
    now.getHours() * 60 + now.getMinutes()
  ) {
    return true;
  }
};
export const compaireTwoDate = (date, now, time) => {
  if (new Date(date).getTime() == new Date(now).getTime()) {
    if (compareTwoHour(time)) {
      return true;
    } else {
      return "today";
    }
  }

  return new Date(date) < new Date(now);
};
export const changeHMtoDate = date => {
  date = date.split(":");
  let newDate = new Date();
  newDate.setHours(date[0]);
  newDate.setMinutes(date[1]);
  return newDate;
};
export const convertKeys = (arr = [], order = {}) => {
  let keysOrder = Object.keys(order);
  const renderObj = obj => {
    return keysOrder.reduce((prev, currentValue) => {
      return {
        ...prev,
        [order[currentValue]]: obj[currentValue],
      };
    }, {});
  };
  return arr.map(element => renderObj(element));
};
